import _slicedToArray from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
import { DEFAULT_CONFIG } from '../../model/config/default';
import { ConfigContext } from './context';
import { configReducer } from './reducer';
export function ConfigProvider(_ref) {
  var config = _ref.config,
      children = _ref.children;

  var _useReducer = useReducer(configReducer, Object.assign(Object.assign({}, DEFAULT_CONFIG), config)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      reducedConfig = _useReducer2[0],
      dispatch = _useReducer2[1];

  return _jsx(ConfigContext.Provider, {
    value: {
      config: reducedConfig,
      updateConfig: dispatch
    },
    children: children
  }, void 0);
}